/* eslint-disable */
import React from 'react';
import LegacyProfile from '../legacyProfileSection/LegacyProfile';

const WholeMeProfileLegacyProfile = ({ legacyProfileData, onEdit, isViewOnly }) => {
  return <LegacyProfile legacyProfileData={legacyProfileData} onEdit={onEdit} isViewOnly={isViewOnly} />;
};

export default WholeMeProfileLegacyProfile;
